import React from 'react';

import { useProteoRisk } from './context';
import { getCookieDaysLeft } from '../WebserverUser';

export default function Settings() {
  const { theme, setTheme, cookieId, contract } = useProteoRisk();
  const pipeline = contract?.pipeline || null;
  return (
    <div className="PROTEORISK-settings-container">
      <div className="PROTEORISK-settings-content">
        <div className="PROTEORISK-settings-header">
          <h1>Settings</h1>
          <p>Configure your ProteoRisk experience</p>
        </div>

        <div className="PROTEORISK-settings-grid">
          <div className="PROTEORISK-settings-section">
            <div className="PROTEORISK-settings-section-header">
              <div className="PROTEORISK-settings-section-icon"><i className="fas fa-palette" aria-hidden="true" /></div>
              <div>
                <h2>Appearance</h2>
                <p>Customize the look and feel</p>
              </div>
            </div>
            <div className="PROTEORISK-settings-section-content">
              <div className="PROTEORISK-setting-row">
                <span className="PROTEORISK-setting-label">Theme</span>
                <div className="PROTEORISK-theme-toggle">
                  <button
                    type="button"
                    className={`PROTEORISK-theme-btn ${theme === 'dark' ? 'active' : ''}`}
                    onClick={() => setTheme('dark')}
                    aria-label="Dark theme"
                  >
                    <i className="fas fa-moon" aria-hidden="true" />
                  </button>
                  <button
                    type="button"
                    className={`PROTEORISK-theme-btn ${theme === 'light' ? 'active' : ''}`}
                    onClick={() => setTheme('light')}
                    aria-label="Light theme"
                  >
                    <i className="fas fa-sun" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="PROTEORISK-settings-section">
            <div className="PROTEORISK-settings-section-header">
              <div className="PROTEORISK-settings-section-icon"><i className="fas fa-user-circle" aria-hidden="true" /></div>
              <div>
                <h2>Account</h2>
                <p>Your anonymous browser ID</p>
              </div>
            </div>
            <div className="PROTEORISK-settings-section-content">
              <div className="PROTEORISK-setting-row">
                <span className="PROTEORISK-setting-label">Account ID</span>
                <span className="PROTEORISK-setting-value mono">{cookieId || 'N/A'}</span>
              </div>
              <div className="PROTEORISK-setting-row">
                <span className="PROTEORISK-setting-label">Kept for</span>
                <span className="PROTEORISK-setting-value">{`${getCookieDaysLeft()} more days`}</span>
              </div>
            </div>
          </div>

          <div className="PROTEORISK-settings-section">
            <div className="PROTEORISK-settings-section-header">
              <div className="PROTEORISK-settings-section-icon"><i className="fas fa-info-circle" aria-hidden="true" /></div>
              <div>
                <h2>About</h2>
                <p>Application information</p>
              </div>
            </div>
            <div className="PROTEORISK-settings-section-content">
              <div className="PROTEORISK-setting-row">
                <span className="PROTEORISK-setting-label">Application</span>
                <span className="PROTEORISK-setting-value">ProteoRisk</span>
              </div>
              <div className="PROTEORISK-setting-row">
                <span className="PROTEORISK-setting-label">Version</span>
                <span className="PROTEORISK-setting-value">1.0.0</span>
              </div>
              <div className="PROTEORISK-setting-row">
                <span className="PROTEORISK-setting-label">Pipeline</span>
                <span className="PROTEORISK-setting-value">
                  {pipeline ? `${pipeline.display_name || pipeline.name} ${pipeline.code_version || ''}`.trim() : 'Not loaded'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
